<template>
    <div>
        <div class="text-center">
            <h2 class="text-slate-800 text-2xl font-semibold leading-loose">
                Welcome To 10xTravel+
            </h2>
            <p class="text-slate-500 text-sm font-normal leading-tight">
                Let's add some details before starting
            </p>
        </div>
        <div class="w-full max-w-md mx-auto pt-12">
            <UiInput
                id="phone-number"
                type="text"
                label="Phone Number"
                name="phone"
                placeholder="+1"
                hint="Phone is used for support only, no spam"
                class="mb-4"
                v-model:inputValue="phone"
                mask-pattern="(###)-###-####"
            />
            <UiSelect
                id="t-shirt-size"
                label="T-shirt size"
                placeholder="Select size"
                name="t-shirt-size"
                :select-options="[
                    { label: 'S', value: 'small' },
                    { label: 'M', value: 'medium' },
                    { label: 'L', value: 'large' },
                    { label: 'XL', value: 'extra-large' },
                    { label: 'XXL', value: 'double-extra-large' },
                ]"
                value-key="value"
                class="mb-4"
                v-model:inputValue="tshirtSize"
                hint="We'll send you a T-shirt"
                @on-change="setTshirtSize"
            />
        </div>
        <div
            class="w-full max-w-md mx-auto flex justify-end gap-6 items-center"
        >
            <button type="button" @click="skip()">Skip</button>
            <button
                type="button"
                class="btn btn-primary"
                @click="continueSetup()"
            >
                Continue
            </button>
        </div>
    </div>
</template>
<script setup>
import { useRouter } from 'vue-router';
import { ref, onMounted } from 'vue';
import UiInput from '@/components/ui/inputs/ui-input.vue';
import UiSelect from '@/components/ui/inputs/ui-select.vue';

const router = useRouter();
const verifyingSubscription = ref(false);
const phone = ref(null);
const tshirtSize = ref(null);

const checkSubscriptionStatus = () => {
    verifyingSubscription.value = true;
    axios
        .get('/api/travel-plus/subscription/status')
        .then((response) => {
            console.log(response);
            verifyingSubscription.value = false;
        })
        .catch((response) => {
            console.log(response);
            verifyingSubscription.value = false;
        });
};

const skip = () => {
    router.push({ name: 'TravelPlus' });
};

const continueSetup = () => {
    axios
        .post('/api/travel-plus/setup', {
            travel_plus_phone_number: phone.value,
            shirt_size: tshirtSize.value,
        })
        .then((response) => {
            router.push({ name: 'TravelPlus' });
        })
        .catch((response) => {
            console.log(response);
        });
};

const setTshirtSize = (value) => {
    // value.value
};

onMounted(() => {
    checkSubscriptionStatus();
});
</script>
